export default __webpack_public_path__ + "static/media/external-link-icon.40775482.svg";